export default "__VITE_ASSET__spfND421__"